import React, { useEffect } from "react";
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import Home6 from "./components/Home6";
import AboutSection from "./components/AboutSection";
import ServiceSection from "./components/ServiceSection";
import FeatureSection from "./components/FeatureSection";
import ClientSection from "./components/ClientSection";
import BlogSection from "./components/BlogSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FooterAlt from "./components/FooterAlt";
import { Carousel2 } from "./components/Carousel";
import NewsSection from "./components/NewsSection";

const Index6 = ({ isAuth, isAdmin, news }) => {
  useEffect(() => {
    document.getElementById("main_navbar").classList.add("navbar-light");
  }, []);

  return (
    <React.Fragment>
      {/* preloader */}
      <Preloader />

      {/* Navigation Menu */}
      <Navbar isAdmin={isAdmin} isAuth={isAuth} />

      {/* HomeSection Menu */}
      <Home6 />

      {/* AboutSection Menu */}
      <AboutSection />

      {/* ServiceSection Menu */}
      <ServiceSection />

      {/* Carousel */}
      <Carousel2 />

      {/* ClientSection Menu */}
      <ClientSection />

      {/* FeatureSection Menu */}
      <FeatureSection />

      {/* BlogSection Menu */}
      {/*<BlogSection />*/}


      {/* BlogSection Menu */}
      {/** <NewsSection news={news} /> **/}


      {/* ContactSection Menu */}
      <section className="section bg-light" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-heading mb-5">
                <h3 className="text-dark mb-1 font-weight-light text-uppercase">
                  Contacto
                </h3>
                <div className="title-border-simple position-relative" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="contact-info-box p-4 h-100">
                <h5 className="text-dark mb-3">Teléfonos</h5>
                <p className="text-muted mb-2"><i className="fas fa-phone-alt mr-2" />312 818 90 30 - 570 05 64</p>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="contact-info-box p-4 h-100">
                <h5 className="text-dark mb-3">Dirección</h5>
                <p className="text-muted mb-2"><i className="fas fa-map-marker-alt mr-2" />Kra 15 # 22 -40 del Barrio 12 de Octubre<br />Valledupar - Cesar</p>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="contact-info-box p-4 h-100">
                <h5 className="text-dark mb-3">Correo electrónico</h5>
                <p className="text-muted mb-2"><i className="far fa-envelope mr-2" />coorrenacer@hotmail.com</p>
                <p className="text-muted mb-2"><i className="fas fa-envelope mr-2" />coorrenacervalledupar@gmail.com</p>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-12">
              <div className="contact-info-box p-4 h-100">
                <h5 className="text-dark mb-3">Redes sociales</h5>
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100008292829014" className="text-muted d-flex align-items-center flex-row">
                  <i className="fab fa-facebook fa-2x" />
                  <span className="ml-2">Coorrenacer Reciclaje Organizado</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Footer Menu */}
      <Footer />

      {/* FooterAlt Menu */}
      <FooterAlt />
      {/* Galería OCULTA */}
      {/** Aquí iría la sección de galería, actualmente oculta **/}

      {/* PQR OCULTA */}
      {/** Aquí iría la sección de PQR, actualmente oculta **/}
    </React.Fragment>
  );
};

export default Index6;
